import styled from 'styled-components';

export const CircularProgressBarStyled = styled.svg`
  position: relative;
`;

export const BackgroundCircle = styled.circle`
  position: relative;
  fill: none;
  stroke: rgba(255, 255, 255, 0.2);
`;

export const ProgressCircle = styled.circle`
  position: relative;
  stroke: white;
  fill: none;
  will-change: transform;
`;
